import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

export const createForceIndex = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 13;
  const method = (values.Method as string) ?? "Simple";
  const fiS = readStyle(styles, "fi", "#2196F3");

  return {
    name: "force-index",
    shortName: `FI${period}`,
    calcParams: [period, method],
    series: "normal" as const,
    figures: [{ key: "fi", title: `FI${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(fiS.color, 2, lineStyleToKLine(fiS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "fi", title: `FI${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p, maMethod] = (indicator.calcParams ?? [period, method]) as [
        number,
        string,
      ];
      const n = dataList.length;
      const results: Array<{ fi?: number }> = new Array(n);
      results[0] = {};

      const buf: number[] = new Array(p);
      let bufIdx = 0;
      let bufCount = 0;
      let sum = 0;
      const k = 2 / (p + 1);
      let ema = 0;
      let haveEma = false;

      for (let i = 1; i < n; i++) {
        const raw =
          (dataList[i]!.close - dataList[i - 1]!.close) *
          (dataList[i]!.volume ?? 0);

        if (maMethod === "Exponential") {
          if (!haveEma) {
            ema = raw;
            haveEma = true;
            results[i] = {};
          } else {
            ema = (raw - ema) * k + ema;
            if (i >= p) results[i] = { fi: ema };
            else results[i] = {};
          }
          continue;
        }

        const evicted = bufCount === p ? buf[bufIdx]! : 0;
        buf[bufIdx] = raw;
        bufIdx = (bufIdx + 1) % p;
        if (bufCount < p) bufCount++;
        sum += raw - evicted;

        if (i < p) {
          results[i] = {};
        } else {
          results[i] = { fi: sum / p };
        }
      }

      return results;
    },
  };
};
